export default [
	{
		path: '/activity-list',
		name: 'ActivityList',
		component: () => import('@/components/activity/activity-list'),
	},
	{
		path: '/activity/mid-autumn',
		name: 'MidAutumn',
		component: () => import('@/components/activity/Mid-Autumn'),
	},
	{
		path: '/activity/national-day',
		name: 'NationalDay',
		component: () => import('@/components/activity/NationalDay'),
	},
	{
		path: '/activity/national-day/province',
		name: 'NationalDayProvince',
		component: () => import('@/components/activity/NationalDay/Province.vue'),
	},
	{
		path: '/activity/spring-festival',
		name: 'SpringFestival',
		component: () => import('@/components/activity/SpringFestival'),
	},
	{
		path: '/activity/spring-festival/province',
		name: 'SpringFestivalProvince',
		component: () => import('@/components/activity/SpringFestival/Province.vue'),
	},
	// 七夕活动
	{
		path: '/qixi-activity',
		name: 'QixiFestivalActivity',
		component: (resolve) => require(['@/components/activity/qixi-activity'], resolve),
	},
];



// WEBPACK FOOTER //
// ./src/router/modules/operation.js